<template>
  <div>
    <div v-for="order in ordersList" :key="order._id">
      <div class="row border border-dark p-3 rounded-2 mb-5 shadow">
        <div class="col-lg-6">
          <h4 class="mb-3">Contact Info:</h4>
          <div class="row p-2">
            <div class="col-lg-6">
              <p>Name: {{ order.name }}</p>
              <p>Contact: {{ order.phoneNumber }}</p>
              <p>E-mail: {{ order.email }}</p>
              <p>Shipping Address: {{ order.shippingAddress }}</p>
              <p>City: {{ order.city }}</p>
              <p>ZIP Code: {{ order.zip }}</p>
            </div>
            <div class="col-lg-6">
              <p>
                Order Date:
                {{ new Date(order.createdAt).toLocaleDateString() }}
              </p>
              <p>
                Status:
                <span class="fw-bolder text-primary">{{
                  order.orderStatus
                }}</span>
              </p>
              <p>
                Payment:
                <span class="fw-bolder text-primary">
                  {{ order.paymentStatus }}
                </span>
              </p>
              <p>
                Payment Method:
                {{
                  order.paymentMethod === "cashOnDelivery"
                    ? "Cash On Delivery(COD)"
                    : order.paymentMethod
                }}
              </p>
              <p v-if="order.trxId">Transaction ID: {{ order.trxId }}</p>
              <p v-if="order.paymentPhone">
                Transaction Phone no.: {{ order.paymentPhone }}
              </p>
            </div>
            <div
                v-if="order.remarksForUser.length"
                class="col-lg-12 p-3 rounded text-bg-warning shadow my-2"
            >
              <p class="p-0 m-0 fw-bolder">Notes from Support Team</p>
              <hr>
              <div
                v-for="(remark, i) in order.remarksForUser"
                :key="`remark-${i}`"
                class="mb-2"
                type="text"
                disabled
              >
                - {{ remark }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 card p-3">
          <h4>Product List:</h4>
          <div
            v-for="item in order.items"
            :key="item._id"
            class="d-flex justify-content-between py-2 border-bottom gap-1"
          >
            <div style="max-width: 60%;">
              <strong>{{ item.title }}</strong>
              <small class="opacity-50 d-block">
                <span>
                  {{ item.variant.name }}
                </span>
              </small>
            </div>
            <div>
              <span>
                ৳ {{ item.variant.salePrice || item.variant.price }} x {{ item.quantity }}
              </span>
            </div>
            <div>
              {{ (item.variant.salePrice || item.variant.price) * item.quantity }} BDT
            </div>
          </div>
          <div
            class="d-flex justify-content-between py-2 border-top border-3 mt-3"
          >
            <span> Discount: </span>
            <span>{{ order.couponCode }}</span>
            - {{ order.discountAmount }} BDT
          </div>
          <!-- <div
            class="d-flex justify-content-between py-2 border-top border-3 mt-3"
          >
            <span> Payment Gateway charge: </span>
            + {{ order.paymentMethodCharge }} BDT
          </div> -->
          <div
            class="d-flex justify-content-between py-2 border-top border-3 mt-3"
          >
            <span> Delivery charge: </span>
            + {{ order.deliveryCharge }} BDT
          </div>
          <div
            class="d-flex justify-content-between py-2 border-top border-3 mt-3"
          >
            <strong>Total:</strong>
            <strong>{{ order.subTotal }} BDT</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "OrderDetails",
  props: {
    ordersList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
</style>
